import { AuthLayout as BaseAuthLayout } from '@/shared/components/AuthLayout'

export function AuthLayout() {
  return (
    <div className="horizon-page horizon-auth">
      <BaseAuthLayout />
    </div>
  )
}
